import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from './context/UserContext';
import { HelmetProvider } from 'react-helmet-async';
import { initializeAnalyticsAndPerformance, initializeRecaptchaAppCheck } from './firebase';

if (typeof window !== 'undefined') {
  initializeRecaptchaAppCheck();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <UserProvider>
        <App />
      </UserProvider>
    </HelmetProvider>

  </React.StrictMode>
);

const analyticsState = {
  initialized: false
};

const hasAnalyticsConsent = () => {
  try {
    const stored = localStorage.getItem('cookieConsent');
    const parsed = stored ? JSON.parse(stored) : null;
    return parsed?.accepted === true;
  } catch {
    return false;
  }
};

const bootstrapAnalytics = () => {
  if (analyticsState.initialized || !hasAnalyticsConsent()) return;
  initializeAnalyticsAndPerformance()
    .then(() => {
      analyticsState.initialized = true;
    })
    .catch(() => {
      // Ignore failures; analytics are optional.
    });
};

if (typeof window !== 'undefined') {
  bootstrapAnalytics();
  window.addEventListener('cookie-consent-changed', bootstrapAnalytics);
}

reportWebVitals();
